export default class funListLimit{
    constructor(time=1,maxNum=10){
        this.time = time;
        this.maxNum = maxNum;
        this.T = -1;
        this.funList =[];
    }
    add (fun,level=0) {
        if (this.funList.length==0){
            this.start();
        }
        this.funList.push({fun,level});
        this.funList.sort((a,b)=>{
            return a.level - b.level;
        })
        //this.start();
    }
    start(){
        this.T = setInterval(()=>{
          let needRunFunList =  this.funList.splice(0, this.maxNum);
            if (needRunFunList.length==0){
                clearInterval(this.T);
            }else{
                console.log(needRunFunList);
                while (needRunFunList.length>0){
                    let item = needRunFunList.shift();
                    item.fun.call(null);
                }
            }
        },this.time);
    }
};